import * as React from 'react';
import { range } from 'lodash';
import * as classnames from 'classnames';
import { ISlotInfo } from './../index';
import { IUpdateSlotsWithNumber } from '../../../actions';

const ButtonList = (props: IItemFormProps) => {
  const routerGs = props.maxGs / props.gsByPort;
  const steps = range(props.portsBySlot, routerGs + 1, props.portsBySlot);

  return steps.map(step => {
    const isLessThanSelected = step <= props.portsInRouter;
    const isLessThanMaxGs = props.maxGsAvailable >= (step - props.portsInRouter) * props.gsByPort;

    const isEnabled = isLessThanSelected || isLessThanMaxGs;
    const className = classnames({
      selected: step === props.portsInRouter,
      disabled: !isEnabled
    });

    const handleClick = (e: React.FormEvent<EventTarget>) => {
      e.preventDefault();

      const newPortsQty = props.portsInRouter === step ? 0 : step / props.portsBySlot;
      return isEnabled && props.onClick(props.id, newPortsQty);
    };

    return (
      <li key={step} className={className}>
        <button onClick={handleClick}>{step}</button>
      </li>
    );
  });
};

interface IItemFormProps extends ISlotInfo {
  onClick: IUpdateSlotsWithNumber;
}

const ItemForm: React.SFC<IItemFormProps> = props => {
  return (
    <div className="form-group col-xxl-4">
      <label>{props.label}</label>
      <ul className="list-control">{ButtonList(props)}</ul>
    </div>
  );
};

export default ItemForm;



// WEBPACK FOOTER //
// ./src/components/Configurator/FormConfigurator/ItemForm.tsx